import CIMSTable from 'components/CIMSTable'
import { useRouteMatches } from 'hooks/useRouteMatches'
import { useNotificationTemplatesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useColumns } from './hooks/useColumns'

function Templates() {
  const { param } = useRouteMatches()
  const workflowId = param('workflowId')
  const { data, loading } = useNotificationTemplatesQuery({
    ...DefaultQueryHookOptions,
    skip: !workflowId,
    variables: workflowId ? { workflowId } : undefined,
  })

  return (
    <CIMSTable
      rowKey="id"
      records={data?.listNotificationTemplates.records ?? []}
      loading={loading}
      columns={useColumns()}
    />
  )
}

export default Templates
